import { writable } from 'svelte/store';
import type { SessionInfo } from '../types';
import { getSessionInfo } from '../lib/apiService';

// Initial empty settings
const initialSettings: SessionInfo = {
  active_team: { id: '', name: '', team_members: [], default_meeting_location: undefined, club_id: '', club: undefined },
  teams: [{ id: '', name: '', team_members: [], default_meeting_location: undefined, club_id: '', club: undefined }],
  user: { id: '', username: '', messaging_app: 'whatsapp' },
  language: 'nl'
};

export const settingsStore = writable(initialSettings);

// Function to completely clear and reset the store
export function clearSettings() {
  settingsStore.set(initialSettings);
}

// Function to refresh settings from API
export function refreshSettings() {
  return new Promise((resolve, reject) => {
    getSessionInfo((result, status) => {
      if (status === 200) {
        settingsStore.set(result);
        resolve(result);
      } else if (status === 401) {
        // For 401 Unauthorized, clear the store and localStorage token
        settingsStore.set(initialSettings);
        localStorage.removeItem('token');
        resolve(null);
      } else {
        // Handle other errors if needed
        reject(new Error(`Unexpected status: ${status}`));
      }
    });
  });
} 